export enum NotificationClass {
    SUCCESS = 'notification-success',
    ERROR = 'notification-error',
    WARNING = 'notification-warning',
}
